var render = function () {
  var _vm$selectionConfig, _vm$editingConfig, _vm$editingConfig2, _vm$actions, _vm$actions$filter;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "dx-wrapper",
    attrs: {
      "show": false,
      "opacity": 0.3,
      "rounded": "sm"
    }
  }, [_vm._l(_vm.actions, function (action, index) {
    return action.danger ? _c('delete-dialog', {
      key: index,
      ref: "deleteDialog",
      refInFor: true,
      attrs: {
        "data-remove": function (data) {
          return {
            title: _vm.$t('ar_common_confirm_delete'),
            content: action.dialogContent ? action.dialogContent(data) : _vm.$t('ar_common_are_you_sure_delete')
          };
        }
      },
      on: {
        "deleteItem": function (data) {
          return _vm.$emit(("action-" + (index + 1)), data);
        }
      }
    }) : _vm._e();
  }), _vm.customComponent ? _c(_vm.customComponent, {
    tag: "component"
  }) : _vm._e(), _c('DxDataGrid', {
    ref: "dxDatagridRef",
    staticStyle: {
      "max-height": "500px"
    },
    attrs: {
      "hover-state-enabled": true,
      "remote-operations": true,
      "noDataText": _vm.$t('ar_common_no_data'),
      "word-wrap-enabled": true,
      "column-resizing-mode": _vm.columnResizingMode,
      "data-source": _vm.rawDataSource,
      "show-column-lines": true,
      "show-row-lines": true,
      "show-borders": true
    },
    on: {
      "contentReady": _vm.onContentReady,
      "editor-preparing": _vm.onEditorPreparing,
      "option-changed": _vm.handlePropertyChange,
      "selection-changed": function ($event) {
        return _vm.$emit('selection-changed', $event);
      },
      "cellClick": _vm.onCellClick
    },
    scopedSlots: _vm._u([{
      key: "export",
      fn: function () {
        return [_c('b-dropdown', {
          attrs: {
            "id": "dropdown-left",
            "text": _vm.$t('ar_client_export'),
            "variant": "outline-primary"
          }
        }, [_c('b-dropdown-item', {
          staticClass: "text-wrap",
          attrs: {
            "href": "#"
          },
          on: {
            "click": _vm.handleExportExcel
          }
        }, [_vm._v(_vm._s(_vm.$t("ar_client_export_excel")))]), _c('b-dropdown-item', {
          staticClass: "text-wrap",
          attrs: {
            "href": "#",
            "disabled": true
          }
        }, [_vm._v(_vm._s(_vm.$t("ar_client_export_pdf")))])], 1)];
      },
      proxy: true
    }, {
      key: "showHideColumn",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "id": "column-chooser-button",
            "variant": "outline-primary"
          },
          on: {
            "click": function ($event) {
              return _vm.$refs.dxDatagridRef.instance.showColumnChooser();
            }
          }
        }, [_c('ez-icon', {
          attrs: {
            "icon": "ezAr-icon-align-justify"
          }
        }), _vm._v(" " + _vm._s(_vm.$t("ar_client_hide_column")) + " ")], 1)];
      },
      proxy: true
    }, {
      key: "beforeToolbarActions",
      fn: function () {
        return [_vm._t("beforeToolbarActions")];
      },
      proxy: true
    }, {
      key: "toolbarActions",
      fn: function () {
        return [_vm._t("toolbar")];
      },
      proxy: true
    }, {
      key: "index",
      fn: function (_ref) {
        var data = _ref.data;
        return [_vm._v(_vm._s(data.row.loadIndex + 1))];
      }
    }, _vm._l(_vm.columns, function (item) {
      return {
        key: _vm.renderSlotHeader(item.field),
        fn: function (_ref2) {
          var data = _ref2.data;
          return [item.formatType === 'currency' ? _c('span', [_vm._v(" " + _vm._s(data.column.caption) + " (VND) ")]) : item.captionAfterFix ? _c('span', [_vm._v(" " + _vm._s(data.column.caption + item.captionAfterFix) + " ")]) : _c('div', {
            staticClass: "d-flex"
          }, [_vm._v(" " + _vm._s(data.column.caption) + " ")])];
        }
      };
    }), _vm.templateArr.length > 0 ? _vm._l(_vm.columns, function (item) {
      return {
        key: item.field,
        fn: function (_ref3) {
          var data = _ref3.data;
          return [item.cellRender ? _c('span', {
            on: {
              "click": function ($event) {
                return _vm.$emit(((item.field) + "-action"), data);
              }
            }
          }, [_vm._v(" " + _vm._s(item.cellRender(data)) + " ")]) : !data.data[item.field] && item.defaultIfEmpty ? _c('span', [_vm._v(" " + _vm._s(item.defaultIfEmpty) + " ")]) : item.fieldParentKey ? _c('span', [_vm._v(" " + _vm._s(data.data[item.fieldParentKey][item.field]) + " ")]) : item.formatType === 'currency' || item.formatType === 'num' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatPrice(data.data[item.field])) + " ")]) : item.formatType === 'date' ? _c('span', [_vm._v(" " + _vm._s(data.data[item.field] ? _vm.renderDate(data.data[item.field], item.dateConfig) : "") + " ")]) : item.formatType === 'truncate' ? _c('span', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: {
                "hover": true
              }
            }],
            staticClass: "truncate",
            style: _vm.truncateWidth(item.truncateWidth),
            attrs: {
              "title": data.data[item.field]
            }
          }, [_vm._v(" " + _vm._s(data.data[item.field]) + " ")]) : item.formatType === 'text-variant' && item.renderTextVariant ? _c('span', {
            class: ("text-" + (item.renderTextVariant(data.data[item.field]).variant))
          }, [_vm._v(" " + _vm._s(_vm.$t(item.renderTextVariant(data.data[item.field]).title)) + " ")]) : _vm._t(item.field, null, {
            "data": data
          })];
        }
      };
    }) : null, {
      key: "action",
      fn: function (_ref4) {
        var data = _ref4.data;
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center",
          staticStyle: {
            "gap": "10px"
          }
        }, [_vm._l(_vm.actionsSplit.iconActions, function (action, index) {
          return _vm.actionsSplit.iconActions.length > 0 ? _c('span', {
            class: {
              'd-none': !_vm.forceDisplayActions && !_vm.isValidPermission(action.apiCode)
            }
          }, [_c('span', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: {
                "hover": true
              }
            }],
            attrs: {
              "title": action.title ? _vm.$t(action.title) : ''
            }
          }, [_c('ez-icon', {
            key: index,
            staticClass: "cursor-pointer",
            attrs: {
              "icon": 'ezAr-icon-' + action.icon,
              "size": "18",
              "color": action.danger ? '#EA5455' : '#114A9F'
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                action.danger && !Array.isArray(_vm.$refs.deleteDialog) && !action.direct ? _vm.$refs.deleteDialog.open(data) : action.danger && !action.direct ? _vm.$refs.deleteDialog[0].open(data) : _vm.$emit(("action-" + (index + 1)), data);
              }
            }
          })], 1)]) : _vm._e();
        }), _vm.actionsSplit.dropDownActions.length > 2 ? _c('b-dropdown', {
          staticClass: "w-100",
          attrs: {
            "menu-class": "w-100",
            "size": "lg",
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": "",
            "right": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function () {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "color": "#114A9F"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, _vm._l(_vm.actionsSplit.dropDownActions, function (action, index) {
          return _c('b-dropdown-item', {
            key: index,
            attrs: {
              "href": "#"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                action.danger && !Array.isArray(_vm.$refs.deleteDialog) ? _vm.$refs.deleteDialog.open(data) : action.danger ? _vm.$refs.deleteDialog[data.rowIndex].open(data) : _vm.$emit(("action-" + (index + 1)), data);
              }
            }
          }, [action.danger ? _c('delete-dialog', {
            ref: "deleteDialog",
            refInFor: true,
            attrs: {
              "data-remove": {
                title: _vm.$t('ar_common_confirm_delete'),
                content: _vm.$t('ar_common_are_you_sure_delete')
              }
            },
            on: {
              "deleteItem": function ($event) {
                return _vm.$emit(("action-" + (index + 1)), data);
              }
            }
          }) : _vm._e(), _c('span', {
            class: action.danger ? 'text-danger' : ''
          }, [_vm._v(" " + _vm._s(action.title ? _vm.$t(action.title) : "") + " ")])], 1);
        }), 1) : _vm._e()], 2)];
      }
    }], null, true)
  }, [!_vm.toolbarConfig.disableToolbar ? _c('DxColumnChooser', {
    attrs: {
      "enabled": true,
      "title": this.$t('ar_common_showhide_column'),
      "mode": "select"
    }
  }, [_c('DxPosition', {
    attrs: {
      "my": "center top",
      "at": "left bottom",
      "of": "#column-chooser-button"
    }
  })], 1) : _vm._e(), !_vm.toolbarConfig.disableToolbar ? _c('DxToolbar', [_c('DxItem', {
    attrs: {
      "location": "before",
      "template": "beforeToolbarActions"
    }
  }), _c('DxItem', {
    attrs: {
      "location": "after",
      "template": "toolbarActions"
    }
  }), _vm.excelExport && _vm.isValidPermission(_vm.excelExportApiCode) ? _c('DxItem', {
    attrs: {
      "location": "after",
      "template": "export"
    }
  }) : _vm._e(), !_vm.toolbarConfig.disableColumnChooser ? _c('DxItem', {
    attrs: {
      "template": "showHideColumn",
      "locate-in-menu": "auto",
      "location": "after"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.hasSelectionChangeListener && !_vm.selectionConfig.hideSelect ? _c('DxSelection', {
    attrs: {
      "mode": ((_vm$selectionConfig = _vm.selectionConfig) === null || _vm$selectionConfig === void 0 ? void 0 : _vm$selectionConfig.mode) || 'multiple'
    }
  }) : _vm._e(), _vm.editable ? _c('DxEditing', {
    attrs: {
      "allow-deleting": (_vm$editingConfig = _vm.editingConfig) === null || _vm$editingConfig === void 0 ? void 0 : _vm$editingConfig.delete,
      "allow-updating": true,
      "mode": ((_vm$editingConfig2 = _vm.editingConfig) === null || _vm$editingConfig2 === void 0 ? void 0 : _vm$editingConfig2.mode) || 'cell'
    }
  }) : _vm._e(), _c('DxColumn', {
    attrs: {
      "caption": "STT",
      "alignment": "center",
      "width": "50",
      "cell-template": "index"
    }
  }), _vm._l(_vm.columns, function (item, index) {
    var _item$visible, _item$editingConfig;
    return _c('DxColumn', {
      key: index,
      attrs: {
        "visible": (_item$visible = item.visible) !== null && _item$visible !== void 0 ? _item$visible : true,
        "css-class": item.cssClass,
        "caption": item.caption ? _vm.$t(item.caption) : '',
        "data-field": item.field,
        "header-cell-template": _vm.renderSlotHeader(item.field),
        "cell-template": item.cellTemplate ? item.field : false,
        "allow-column-resizing": true,
        "column-auto-width": true,
        "min-width": item.minWidth,
        "alignment": item.align || _vm.renderColAlign(item.formatType),
        "width": item.width || _vm.calculateWidth(item.formatType),
        "allowFiltering": item.field != 'action' ? true : false
      }
    }, [item.editingConfig && item.editingConfig.required ? _c('DxRequiredRule') : _vm._e(), _vm._l((_item$editingConfig = item.editingConfig) === null || _item$editingConfig === void 0 ? void 0 : _item$editingConfig.rules, function (rule, index) {
      var _item$editingConfig2;
      return item.editingConfig && (_item$editingConfig2 = item.editingConfig) !== null && _item$editingConfig2 !== void 0 && _item$editingConfig2.rules ? _c('DxCustomRule', {
        key: rule.message,
        attrs: {
          "validation-callback": rule.callback,
          "message": _vm.$t(rule.message)
        }
      }) : _vm._e();
    })], 2);
  }), _vm.forceDisplayActions || _vm.isSuperAdmin && ((_vm$actions = _vm.actions) === null || _vm$actions === void 0 ? void 0 : _vm$actions.length) > 0 || ((_vm$actions$filter = _vm.actions.filter(function (action) {
    return _vm.permissionList.includes(action.apiCode);
  })) === null || _vm$actions$filter === void 0 ? void 0 : _vm$actions$filter.length) > 0 ? _c('DxColumn', {
    attrs: {
      "fixed": true,
      "fixed-position": "right",
      "showInColumnChooser": false,
      "caption": _vm.$t('ar_common_operation'),
      "alignment": "center",
      "cssClass": "action-column",
      "width": "100px",
      "cell-template": "action"
    }
  }) : _vm._e(), _c('DxPaging', {
    attrs: {
      "enabled": !_vm.pageConfig.disablePagination,
      "page-size": _vm.pageConfig.pageSize || 20
    }
  }), _c('DxPager', {
    attrs: {
      "visible": !_vm.pageConfig.disablePagination,
      "allowed-page-sizes": _vm.pageConfig.pageSizes || [10, 20, 40, 0],
      "display-mode": _vm.pageConfig.displayMode || 'full',
      "show-info": _vm.pageConfig.ShowInfo || true,
      "show-navigation-buttons": _vm.pageConfig.showNavigationButtons || true,
      "show-page-size-selector": _vm.pageConfig.showPageSizeSelector || true,
      "info-text": ((_vm.$t('Page')) + " {0} " + (_vm.$t('of')) + " {1} ({2} " + (_vm.$t('record')) + ")")
    }
  }), _c('DxScrolling', {
    attrs: {
      "column-rendering-mode": "virtual"
    }
  })], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }